import { CUIColors, IconNames } from '@dotcom/crown-ui';
import userZoneAddPhotoIconUS from '../../assets/user-zone-add-photo-icon-us.svg';
import userZoneAddTextIconUS from '../../assets/user-zone-add-text-icon-us.svg';
import userZoneAddWamIconUS from '../../assets/user-zone-add-wam-icon-us.svg';
import { DeliveryModes } from '../../components/address-form/address-form-types';
import { HeaderVariants } from '../../components/print-on-demand-header/print-on-demand-header-types';
import { RegionalCodesList } from '../../global-types';
import { TextEditorDrawerType } from '../../global-types/regions-list';
import colorsList from '../../styles/util.scss';
import { RegionalSchema } from '../regional-config-types';
import { buttons } from '../../themes/us/buttons';

export const configUS: RegionalSchema = {
  deliveryMode: DeliveryModes.None,
  cardEditor: {
    faceTypeText: true,
    textEditorDrawerType: TextEditorDrawerType.Side,
    lastCardFaceRoute: 'address',
  },
  cardSelectBar: {
    containerClass: 'footer',
  },
  saveProjects: {
    isSavedProjectsEnabled: true,
    saveButton: {
      type: 'LoadingButton',
      iconName: IconNames.SyncSyncInactive,
    },
    hasSignInDialog: false,
  },
  addressForm: {
    handleZipChange: false,
    shouldShowOneToManyEnvelopePreview: true,
  },
  header: {
    svgColor: CUIColors.Purple,
    saveDialogTheme: RegionalCodesList.us,
    variant: HeaderVariants.US,
    quantityLink: true,
  },
  userZones: {
    addTextIcon: userZoneAddTextIconUS,
    addPhotoIcon: userZoneAddPhotoIconUS,
    addWAMIcon: userZoneAddWamIconUS,
    areInstructionsEnabled: false,
  },
  scssStyles: {
    appBackground: colorsList[CUIColors.EditorBackground],
    headerBackgroundMobile: colorsList[CUIColors.White],
    'primary-button-background-color': buttons.primaryButtonBackgroundColor,
    'secondary-button-border-color': buttons.secondaryButtonBorderColor,
    'primary-button-disabled-border-color': buttons.primaryButtonDisabledBorderColor,
    'primary-button-disabled-background-color': buttons.primaryButtonDisabledBackgroundColor,
    'border-color': buttons.borderColor,
    // secondary-button-background-color is intentionally omitted — crown-ui sets it to white globally
  },
  features: {
    // POD Write a Message includes a WAM button in the toolbar and a WAM button in user zones
    isPodWamEnabledOnlyInside: true,
  },
  isAddressRegulationToastEnabled: true,
  hasUsStates: true,
  skipAddressView: false,
};
